export default "__VITE_ASSET__BvVKmxo1__"